<template>
    <div class='page-start' @scroll="handleScroll">
      <mdb-container class="col-10 pb-3" id="container" fluid>
        <mdb-alert id="feedback-success" class="mt-3" color="success" v-if="p1_success" @closeAlert="p1_success=false" dismiss>
          Success! The change request has been closed!
        </mdb-alert>
        <mdb-alert id="feedback-success" class="mt-3" color="success" v-if="p2_success" @closeAlert="p2_success=false" dismiss>
          Success! Changes have been saved!
        </mdb-alert>

        <!--failure messages-->
        <mdb-alert id="feedback-failure" class="mt-3" color="danger" v-if="p2" @closeAlert="p2=false" dismiss>
          There was an error submitting the changes. Please try again! Error Code P2
        </mdb-alert>
        <mdb-alert id="feedback-failure" class="mt-3" color="danger" v-if="p5_fail" @closeAlert="p5_fail=false" dismiss>
          The email failed to send.
        </mdb-alert>
        
 
        <mdb-card class="mb-3 d-flex">
          <div id="stickyDiv" :class="{sticky: isSticky, hideDiv: isHidden}">
            <h3 class="card-header stylish-color white-text text-center font-weight-bold text-uppercase py-4">
              {{previewCardTitle}}
              <mdb-btn class='QuadrusButton backBtn' v-on:click="returnToITCRs">
                <mdb-icon color="white" fas icon="fas fa-chevron-left" />&nbsp;Back
              </mdb-btn>               
            </h3>

            <mdb-row v-if="ITCRid" class="headerRow">
              <mdb-col>
                <mdb-input class="mb-3" v-model="ITCRid" label="ITCR Number" disabled/>
              </mdb-col>
              <mdb-col>
                <mdb-input class="mb-3" v-model="submitDate" label="Submit Date" disabled/>
              </mdb-col>
              <mdb-col>
                <mdb-input class="mb-3" v-model="submitter" label="Submitter" disabled />
              </mdb-col>
            </mdb-row>
          </div>
          
          
          <div class="fixed-wrapper">
            <div id="stickyHeading" ref="stickyHeading"></div>
            <div>
              <h3 class="card-header stylish-color white-text text-center font-weight-bold text-uppercase py-4">
                {{previewCardTitle}}
                <mdb-btn class='QuadrusButton backBtn' v-on:click="returnToITCRs">
                  <mdb-icon color="white" fas icon="fas fa-chevron-left" />&nbsp;Back
                </mdb-btn>               
              </h3>
            
             <mdb-row v-if="ITCRid" class="headerRow">
              <mdb-col>
                <mdb-input class="mb-3 readonly-inputs" v-model="ITCRid" label="ITCR Number" readOnly/>
              </mdb-col>
              <mdb-col>
                <mdb-input class="mb-3 readonly-inputs" v-model="submitDate" label="Submit Date" readOnly/>
              </mdb-col>
              <mdb-col>
                <mdb-input class="mb-3 readonly-inputs" v-model="submitter" label="Submitter" readOnly />
              </mdb-col>
            </mdb-row>
            <mdb-row v-if="ITCRid" class="headerRow">
                <mdb-col>
                    <mdb-input class="mb-3 no-resize-textarea" type="textarea" :rows="4" outline v-model="changeDescription" label="Change Description" readOnly/>
                </mdb-col>
            </mdb-row>  
          </div>
          </div> 
          <br><br>

          <div>
            <mdb-row class="d-flex align-items-center justify-content-center">
              <mdb-col>
                <h4>Current Stage: {{ this.stage }}</h4>
                <p v-if="discussionRequired"><i>CCB Pending Discussion</i></p>
                <br>
                <mdb-input v-if="!closed" class="mb-0 mt-2" type="checkbox" id="isUrgent" name="isUrgent" v-model="isUrgent" label="Change Request is Urgent"/>
              </mdb-col>
            </mdb-row>
            <br>
            <mdb-row class="d-flex align-items-center justify-content-center">
                <mdb-btn v-if="auditComplete" @click.native="viewAudit = true">View Audit Report</mdb-btn>
                <mdb-btn color="info" v-if="!isIntern && stage != 'Closed'" @click.native="viewCloseConfirm = true">Close Change Request</mdb-btn>
                <mdb-btn v-else-if="!isIntern && stage == 'Closed'" @click.native="returnToITCRs">View ITCR List</mdb-btn>
            </mdb-row>
          </div>
          <br><br>

          <div id="scrollableDiv" ref="scrollableDiv">
            <div v-for="item in stageCompletion.rowData" :id="item.stage" :key="item.stage">
              <mdb-btn v-if="item.stage == stage_Closed" :class="item.stage == stage ? 'outlineBtn' : ''" 
                :style="{backgroundColor: item.color + ' !important', color: 'black !important'}" 
                disabled>{{item.stage}}</mdb-btn>

              <mdb-btn v-else-if="item.stage == stage" class="outlineBtn" :style="{backgroundColor: item.color + ' !important'}" 
                @click.native="completeNextStep(item.stage)">{{item.stage}}</mdb-btn>
              
              <mdb-btn v-else :disabled="(!item.completed && stage != item.stage)" :style="{backgroundColor: item.color + ' !important'}" 
                @click.native="completeNextStep(item.stage)">{{item.stage}}</mdb-btn>

              <span v-if="item.stage != stage_Closed" class="flowchartArrow">&#x2192;</span>
            </div>
          </div>   
          <br>
        </mdb-card>       

      <div v-if="viewModal && ITCRid" ref="viewModal">
        <mdb-card class="mb-3 d-flex">
          <h3 style="position: relative;" class="card-header stylish-color white-text text-center font-weight-bold text-uppercase py-4">
            {{ detailsTitle }}
            <mdb-icon @click.native="resetData" class="closeDetailsBtn" color="light" fas icon="times" />
          </h3>
          <mdb-card-body>
            <mdb-alert id="feedback-failure" class="mt-3" color="danger" v-if="p6_fail" @closeAlert="p6_fail=false" dismiss>
              Missing Required Fields
            </mdb-alert>
            
            <div v-if="this.selectedStage == this.stage_ITCR">
                <form @submit.prevent="" class="was-validated">
                    <mdb-row>
                        <mdb-col>
                            <mdb-input class="mb-3 readonly-inputs" v-model="ITCRid" label="ITCR Number" readOnly/>
                        </mdb-col>
                        <mdb-col>
                            <mdb-input class="mb-3 readonly-inputs" v-model="submitDate" label="Submit Date" readOnly/>
                        </mdb-col>
                        <mdb-col>
                            <mdb-input class="mb-3 readonly-inputs" v-model="submitter" label="Submitter" readOnly />
                        </mdb-col>
                    </mdb-row>

                    <mdb-row>
                      <mdb-col>
                        <mdb-select label="Type" v-model="itcrTypeOptions" required disabled/>
                      </mdb-col>
                    </mdb-row>

                    <mdb-row>
                        <mdb-col>
                            <mdb-input type="textarea" :rows="4" outline class="mb-3 no-resize-textarea" v-model="changeDescription" 
                            label="Description" maxlength="500" readOnly/>
                        </mdb-col>
                    </mdb-row>
                    <br>
                    <mdb-row>
                        <mdb-col>
                            <mdb-input type="textarea" :rows="8" outline class="mb-3 no-resize-textarea" v-model="additionalNotes" 
                            label="Additional Notes" maxlength="5000" readOnly />
                        </mdb-col>
                    </mdb-row>
                </form>
            </div>

            <div v-if="this.selectedStage == this.stage_SIA">
                <form @submit.prevent="" class="was-validated">
                    <mdb-col>
                        <mdb-input class="mb-3 readonly-inputs" v-model="siaReviewerName" label="Name" readOnly/>
                    </mdb-col>
                    <mdb-col>
                        <mdb-select class="mb-3" v-model="siaDispositionOptions" @getValue="siaDisposition = $event" label="Disposition" :disabled="!editing || isWrongUser"/>
                    </mdb-col>
                    <div v-if="editing && siaDisposition == 'Pending'" class="invalid-feedback d-block">Please select an option.</div>
                    <div v-else-if="editing" class="valid-feedback d-block">Looks Good!</div>
                    <mdb-col>
                        <mdb-input class="mb-3 no-resize-textarea" type="textarea" :rows="4" outline v-model="siaNotes" label="Security Impact" :required="editing" :readOnly="!editing || isWrongUser"
                        invalid-feedback="Please Input Notes" valid-feedback="Looks Good!" maxlength="5000" />
                    </mdb-col>
                </form>
            </div>
                        
            <div v-if="this.selectedStage == this.stage_Work">
                <form @submit.prevent="" class="was-validated">
                <mdb-col>
                    <mdb-select search v-model="userOptions" placeholder="Select a user" @getValue="techAssignedToWork = $event" :disabled="!editing || isWrongUser"/>
                </mdb-col>
                <div v-if="editing && !techAssignedToWork" class="invalid-feedback d-block">Please select an option.</div>
                <div v-else-if="editing" class="valid-feedback d-block">Looks Good!</div>
                <mdb-col>
                    <mdb-select class="mb-3" v-model="workDispositionOptions" @getValue="workDisposition = $event" label="Disposition" :disabled="!editing || isWrongUser"/>
                </mdb-col>
                <div v-if="editing && workDisposition == ''" class="invalid-feedback d-block">Please select an option.</div>
                <div v-else-if="editing" class="valid-feedback d-block">Looks Good!</div>
                <mdb-col>
                    <mdb-input class="mb-3 no-resize-textarea" type="textarea" :rows="4" outline v-model="workNotes" label="Notes" :required="editing" :readOnly="!editing || isWrongUser" 
                    invalid-feedback="Please Input Notes" valid-feedback="Looks Good!" maxlength="5000"/>
                </mdb-col>
                </form>
            </div>
            
            <div v-if="this.selectedStage == this.stage_Verification">
                <form @submit.prevent="" class="was-validated">
                <mdb-col>
                    <mdb-input class="mb-3 readonly-inputs" v-model="testReviewer" label="Name" readOnly/>
                </mdb-col>
                <mdb-col>
                    <mdb-select class="mb-3" v-model="verificationDispositionOptions" @getValue="verificationPass = $event" label="Disposition" :disabled="!editing || isWrongUser"/>
                </mdb-col>
                <div v-if="editing && verificationPass == 'Pending'" class="invalid-feedback d-block">Please select an option.</div>
                <div v-else-if="editing" class="valid-feedback d-block">Looks Good!</div>
                <mdb-col>
                    <mdb-input class="mb-3 no-resize-textarea" type="textarea" :rows="4" outline v-model="verificationNotes" label="Notes" 
                    maxlength="5000" :required="editing" :readOnly="!editing || isWrongUser" 
                    invalid-feedback="Please Input Notes" valid-feedback="Looks Good!"/>
                </mdb-col>
                </form>
            </div>
            
            <div v-if="this.selectedStage.includes('CCB')">
              <p v-if="discussionRequired"><i>IT CCB Pending Discussion</i></p>
              
              <div class="fadeIn">
                <div v-if="editing && !isWrongUser && !discussionRequired">
                    <mdb-col>
                        <p><i>Enter comments below and select a disposition</i></p>
                    </mdb-col>
                    <mdb-input label='Comments' v-model="new_comments_CCB" outline type='textarea' :rows="8" maxlength="500"/>
                    <mdb-row>
                      <mdb-col class="d-flex align-items-center justify-content-center">
                        <mdb-select style="width: 50%;" label="Disposition" @getValue="setDisposition" v-model="userDisposition"/>
                      </mdb-col>
                    </mdb-row>
                    <mdb-row>
                      <mdb-col style="width: 50% !important; text-align: center !important;">
                        <div v-if="!selectedDisposition" class="invalid-feedback d-block">Please select an option.</div>
                        <div v-else class="valid-feedback d-block">Looks Good!</div>
                      </mdb-col>
                    </mdb-row>
                    <br>
                    <mdb-row class="d-flex align-items-center justify-content-center">
                      <mdb-col>
                        <mdb-btn class="m-4" v-if="editing && !isWrongUser" color="outline-mdb-color" type="submit" v-on:click="discussITCR">Discussion Needed</mdb-btn>
                        <mdb-btn class="m-4 QuadrusButton" v-if="editing && !isWrongUser" type="submit" v-on:click="submitITCRDisposition">Submit Disposition</mdb-btn>
                      </mdb-col>
                    </mdb-row>
                    
                </div><br>

                <mdb-col v-if="(isAdmin || isCM) && stage!='Closed' && editing" style="text-align: left !important; border-top: 2px solid grey; padding: 10px;">
                  <h5>CM Actions</h5>

                  <mdb-row class="d-flex align-items-center justify-content-center">
                    <mdb-btn class="m-4" color="outline-default" type="submit" v-on:click="sendCCBReminder">Send CCB Reminder</mdb-btn>
                    <mdb-btn class="m-4" color="outline-danger" type="submit" v-on:click="markCCBComplete('Disapproved')">Force Disapprove</mdb-btn>
                    <mdb-btn class="m-4" color="outline-primary" type="submit" v-on:click="markCCBComplete('Approved')">Force Approve</mdb-btn>
                  </mdb-row>
                </mdb-col>
                <br>
                
                <mdb-col style="text-align: left !important; border-top: 2px solid grey; padding: 10px;">
                  <h5>IT CCB Completion Status</h5>

                  <QDataTable id='memberTable' :rowData="this.members.rowData" :filterWords="this.members.filterWords" :headers="this.members.columns"
                  :class="{'hideTable': !isPopUpSetUp, 'fadeIn' : isPopUpSetUp}">
                  </QDataTable>
                  <div style="text-align: center !important" :class="{'hideSpinner': isPopUpSetUp}" class="p-4">
                    <span class="spinner-border spinner-border-xl" id="loadSpinner" role="status" aria-hidden="true"></span>
                  </div>
                </mdb-col>
              </div>
              
            </div>
            <br>

            <mdb-row v-if="!this.selectedStage.includes('CCB')" class="d-flex justify-content-center">
              <mdb-btn class="m-4 QuadrusButton" 
                v-if="selectedStage == stage_Work && workDisposition == 'Incomplete' && editing && !isWrongUser" :disabled="isWrongUser" 
                @click.native="submitData">Save Notes</mdb-btn>
              <mdb-btn class="m-4 QuadrusButton" 
                v-else-if="editing && !isWrongUser" :disabled="isWrongUser" @click.native="submitData">Submit</mdb-btn>
            </mdb-row>
    
          </mdb-card-body>
        </mdb-card>
      </div>

      <mdb-modal size="xl" centered :show="viewAudit" @close="viewAudit = false" style="z-index: 9999 !important;">
            <mdb-modal-header>
            <mdb-modal-title><p class="h2 grey-text">Change Request Audit Report</p></mdb-modal-title>
            </mdb-modal-header>
            <mdb-modal-body style="font-size: 0.9em;">
                <mdb-row>
                    <mdb-col>
                      <mdb-input class="mb-3 readonly-inputs" v-model="auditorName" label="Name" readOnly/>
                    </mdb-col>
                    <mdb-col>
                      <mdb-input class="mb-3 readonly-inputs" type="text" v-model="auditDate" label='Audit Date' id="auditDate" title='Audit Date' readOnly/>
                    </mdb-col>
                </mdb-row>

                <mdb-col>
                    <mdb-input class="mb-3 no-resize-textarea" type="textarea" :rows="4" outline v-model="auditActions" label="Additional Actions" readOnly/>
                </mdb-col>
                <mdb-col>
                    <mdb-input class="mb-3 no-resize-textarea" type="textarea" :rows="4" outline v-model="auditNotes" label="Notes" required readOnly />
                </mdb-col>

                <mdb-col>
                    <mdb-input class="mb-3" v-model="auditDisposition" label="Disposition" disabled/>
                </mdb-col>

            </mdb-modal-body>
            <mdb-modal-footer class="d-flex justify-content-center">
                <mdb-btn color="secondary" @click.native="viewAudit = false">Close</mdb-btn>
            </mdb-modal-footer>
        </mdb-modal>


        <mdb-modal size="xl" centered :show="viewCloseConfirm" @close="viewCloseConfirm = false" style="z-index: 9999 !important;">
            <mdb-modal-header>
            <mdb-modal-title><p class="h2 grey-text">Close Change Request</p></mdb-modal-title>
            </mdb-modal-header>
            <mdb-modal-body style="font-size: 0.9em;">
              <mdb-alert id="feedback-failure" class="mt-3" color="danger" v-if="closeFail" @closeAlert="closeFail=false" dismiss>
                Missing Required Fields
              </mdb-alert>
              <p>This action will close the change request</p>
              <p>Do you wish to continue?</p>
              <form @submit.prevent="" class="was-validated">
                <mdb-col>
                    <mdb-input class="mb-3 no-resize-textarea" type="textarea" :rows="4" outline v-model="closeRequestReason" label="Reason for Closing" required 
                    invalid-feedback="Please Input Reason" valid-feedback="Looks Good!" maxlength="500"/>
                </mdb-col>
              </form>
            </mdb-modal-body>
            <mdb-modal-footer class="d-flex justify-content-between">
                <mdb-btn color="secondary" @click.native="viewCloseConfirm = false">Cancel</mdb-btn>
                <mdb-btn color="danger" v-on:click="closeITCR">Close Change Request</mdb-btn>
            </mdb-modal-footer>
        </mdb-modal>

      </mdb-container>
    </div>
  </template>

  <style>
  /*Project overview diagram*/
  .flowchartArrow{
    font-size: 36px;
  }
  #scrollableDiv{
    overflow: auto;
    white-space: nowrap;
  }
  #scrollableDiv div {
    display: inline-block !important;
    text-align: center;
    text-decoration: none;
  }
  .outlineBtn, .outlineBtn:hover, .outlineBtn:focus{
    outline: none;
    border: 4px;
    border-style: dashed; 
    border-color: #8df578;
  }

  .no-resize-textarea > textarea {
    height: 120px !important;
    max-height: 120px !important;
    overflow-y: auto !important;
    resize: none !important;
    }
    .readonly-inputs input{
    cursor: text !important;
    }

</style>

  <script>
  import {  mdbInput, mdbCard, mdbCardBody, mdbContainer, mdbRow, mdbCol, mdbBtn, mdbAlert, mdbSelect, mdbModal, mdbModalHeader,
    mdbIcon, mdbModalTitle, mdbModalBody, mdbModalFooter} from 'mdbvue';
  import * as DatabaseLib from '@/assets/js/DatabaseLib.js';
  import QDataTable from '@/components/QDataTable.vue';
  import * as sendEmail from '@/assets/js/email.js';
  import { formatDate } from '@/assets/js/formatDate.js';
import sanitizeInput from '../../assets/js/sanitizeInput';
  
  export default {
      name: 'ViewEdititcr',
      components: {
        mdbInput,
        mdbCard,
        mdbCardBody,
        mdbContainer,
        QDataTable,
        mdbRow,
        mdbCol, 
        mdbBtn,
        mdbAlert,
        mdbSelect,
        mdbModal,
        mdbModalHeader,
        mdbModalTitle,
        mdbModalBody,
        mdbModalFooter,
        mdbIcon
      },
    data() {
        return {
          isPopUpSetUp: false,
          isSetUp: false,
          isHidden: true,

          viewCloseConfirm: false,
          viewAudit: false,
          
          userOptions: [],
          siaDispositionOptions: [{text: 'Approved', value: 'Approved'},{text: 'Disapproved', value: 'Disapproved'}],
          workDispositionOptions: [{text: 'Incomplete', value: 'Incomplete'},{text: 'Complete', value: 'Complete'}],
          verificationDispositionOptions: [{text: 'Yes', value: 'Yes'},{text: 'No', value: 'No'}],
          itcrTypeOptions: [{text: "System", value: "System"},{text: "Facility", value: "Facility"}],

          //user groups
          isCM: false,
          isAdmin: false,
          isIT: false,
          isIntern: false,
          isOnlyCCB: false,

          p2: false,
          p1_success: false,
          p2_success: false,
          p5_fail: false,
          p6_fail: false,
          closeFail: false,

          isSticky: false,
          viewModal: false,
          detailsTitle: '',
          isWrongUser: false,
          selectedStage: '',
          previewCardTitle: '',
          editing: false,

          ITCRid: '',
          submitDate: '',
          
          submitter: '',
          changeDescription: '',
          additionalNotes: '',
          itcrType: '',
          
          closeDate: '',
          stage: '',
          siaReviewerName: '',
          siaNotes: '',
          siaDisposition: '',
          techAssignedToWork: '',
          workDisposition: '',
          workNotes: '',
          testReviewer: '',
          verificationPass: '',
          verificationNotes: '',
          siaCompletionDate: '',
          workCompletionDate: '',
          ccbCompletionDate: '',
          closed: '',
          ccbDisposition: '',
          new_comments_CCB: '',
          auditComplete: false,
          auditDate: '',
          auditorName: '',
          auditDisposition: '',
          auditNotes: '',
          auditActions: '',
          discussionRequired: false,
          closeRequestReason: '',
          ccbs: [],
          isUrgent: false,

          userDisposition: [{text: "Approved", value: "Approved"},{text:"Disapproved", value: "Disapproved"}],
          selectedDisposition: '',
          
          stages: [{stage: "ITCR", type: "form", color: "#0e60cc"},  {stage: "SIA", type: "form", color: "#e88946"}, 
                  {stage: "IT CCB", type: "CCB", color: "#bfb524"}, {stage: "IT Work", type: "form", color: "#0e60cc"}, 
                  {stage: "Verification", type: "form", color: "#e88946"}, {stage: "Closed", type: "", color: "#FFFFFF"}],
          stage_ITCR: 'ITCR',
          stage_SIA: 'SIA',
          stage_CCB: 'IT CCB',
          stage_Work: 'IT Work',
          stage_Verification: 'Verification',
          stage_Closed: 'Closed',

          stageCompletion: {
            columns: [
              {
                colTitle: 'Stage',
                sortBy: 'stage'
              },
              {
                colTitle: 'Action',
                sortBy: ''
              }
            ],
            rowData: [],
            filterWords: [
                'stage'
            ]
          },

          members:{
          columns: [  
            {
              colTitle: 'Name',
              sortBy: 'name'
            },
            {
              colTitle: 'IT CCB Dispositions',
              sortBy: 'approved'
            },
            {
              colTitle: 'Comments',
              sortBy: 'comments'
            },
          ],
          rowData: [],
          filterWords: [
            'name',
            'approved',
            'comments'
          ]
        },
      }
    },

    methods: {
      //===========================================================================================
      //	Method Name	:	resetData
      //	Description
      //	-----------------------------------------------------------------------------------------
      //	Reset all data
      //===========================================================================================
      resetData: function(){
        this.viewModal = false;
        this.editing = false;
        this.p6_fail = false;
      },

      handleScroll: function(){
        const element = document.getElementById('stickyHeading');
        const new_rect = element.getBoundingClientRect();
        let docHeight = document.body.scrollHeight;
        let windowHeight = window.innerHeight;
        const isVisible = (new_rect.top >= -100 || (docHeight - 300 <= windowHeight));
        if (isVisible && this.isSticky) {
          this.isHidden = true;
          this.isSticky = false;
        } else if(!isVisible && !this.isSticky) {
          const containWidth = document.getElementById('container');
          const stickyWidth = document.getElementById('stickyDiv');
          stickyWidth.style.width = (containWidth.offsetWidth - 28) + 'px';      
          this.isHidden = false; 
          this.isSticky = true;
        }
      },

      setDisposition: function(value){
        this.selectedDisposition = value;  
      },
      setUrgent: async function(){
        let token = this.$store.getters.getToken;
        try{
          await DatabaseLib.putRequest('strapiDatabase','itcrs',token,this.ITCRid,{data: {urgentRequest: this.isUrgent}});
        }
        catch(e){
          console.log(e);
        }
      },

      populateDropdowns: function() {
        let holdOptions = [{text: 'Approved', value: 'Approved'},{text: 'Disapproved', value: 'Disapproved'}];
        for(let i = 0; i < holdOptions.length; i = i + 1) {
            if (holdOptions[i].value == this.siaDisposition)
            {
                holdOptions[i].selected = true;
            }
        }
        this.siaDispositionOptions = holdOptions;

        holdOptions = [{text: 'Incomplete', value: 'Incomplete'},{text: 'Complete', value: 'Complete'}];
        for(let i = 0; i < holdOptions.length; i = i + 1) {
            if (holdOptions[i].value == this.workDisposition)
            {
                holdOptions[i].selected = true;
            }
        }
        this.workDispositionOptions = holdOptions;

        holdOptions = [{text: 'Yes', value: 'Yes'},{text: 'No', value: 'No'}];
        for(let i = 0; i < holdOptions.length; i = i + 1) {
            if (holdOptions[i].value == this.verificationPass)
            {
                holdOptions[i].selected = true;
            }
        }
        this.verificationDispositionOptions = holdOptions;

        holdOptions = [{text: "System", value: "System"},{text: "Facility", value: "Facility"}];
        for(let i = 0; i < holdOptions.length; i = i + 1) {
            if (holdOptions[i].value == this.itcrType)
            {
              holdOptions[i].selected = true;
            }
        }
        this.itcrTypeOptions = holdOptions;
      },

      //===========================================================================================
      //	Method Name	:	loadITCRData
      //	Description
      //	-----------------------------------------------------------------------------------------
      //	Gets all the itcr information for the selected itcr
      //===========================================================================================
      loadITCRData: async function(){
        this.editing = false;
        this.stageCompletion.rowData.splice(0);
        let token = this.$store.getters.getToken;
        let query = "filters[id][$in][0]=" + this.ITCRid + "&populate[1]=ccbs";
        let response = await DatabaseLib.getRequest('strapiDatabase','itcrs',token,query,false);

        this.ITCRid = response.data.data[0].id;
        this.submitDate = formatDate(response.data.data[0].attributes.submitDate);
        this.closeDate = response.data.data[0].attributes.closeDate;
        this.submitter = response.data.data[0].attributes.submitter;
        this.changeDescription = response.data.data[0].attributes.changeDescription;
        this.additionalNotes = response.data.data[0].attributes.additionalNotes;
        this.stage = response.data.data[0].attributes.stage;
        this.siaReviewerName = response.data.data[0].attributes.siaReviewerName;
        this.siaCompletionDate = response.data.data[0].attributes.siaCompletionDate;
        this.siaDisposition = response.data.data[0].attributes.siaDisposition;
        this.siaNotes = response.data.data[0].attributes.siaNotes;
        this.techAssignedToWork = response.data.data[0].attributes.techAssignedToWork;
        this.workCompletionDate = response.data.data[0].attributes.workCompletionDate;
        this.workDisposition = response.data.data[0].attributes.workDisposition;
        this.workNotes = response.data.data[0].attributes.workNotes;
        this.testReviewer = response.data.data[0].attributes.testReviewer;
        this.verificationNotes = response.data.data[0].attributes.verificationNotes;
        this.verificationPass = response.data.data[0].attributes.verificationPass == 'Pass' 
          ? 'Yes' : response.data.data[0].attributes.verificationPass == 'Fail' ? 'No' : 'Pending';
        this.ccbCompletionDate = response.data.data[0].attributes.ccbCompletionDate;
        this.closed = response.data.data[0].attributes.closed;
        this.ccbDisposition = response.data.data[0].attributes.ccbDisposition;
        this.auditComplete = response.data.data[0].attributes.auditComplete;
        this.auditActions = response.data.data[0].attributes.auditActions;
        this.auditNotes = response.data.data[0].attributes.auditNotes;
        this.auditDate = formatDate(response.data.data[0].attributes.auditDate);
        this.auditDisposition = response.data.data[0].attributes.auditDisposition;
        this.auditorName = response.data.data[0].attributes.auditorName;
        this.discussionRequired = response.data.data[0].attributes.discussionRequired;
        this.closeRequestReason = response.data.data[0].attributes.closeRequestReason;
        this.itcrType = response.data.data[0].attributes.itcrType;
        this.ccbs = response.data.data[0].attributes.ccbs.data;
        this.isUrgent = response.data.data[0].attributes.urgentRequest;

        await this.populateDropdowns(); 
        await this.checkGroups();
        this.checkCRTable(); 
        this.loadDiagram();
        if(this.stage != 'Closed'){setTimeout(this.adjustChart, 500);}
      },

      loadDiagram: function(){      
        for(let i = 0; i < this.stages.length; i = i + 1) {
          const index = this.stages.findIndex(item => item.stage === this.stage)
          this.stageCompletion.rowData.push({
            id: i,
            stage: this.stages[i].stage,
            isDoc: this.stages[i].type == "Document" ? true: false,
            completed: i < index ? true : false,
            isCheckOff: this.stages[i].type == "Checkbox" ? true: false,
            isText: this.stages[i].type == "Text" ? true : false,
            color: this.stages[i].color
          })
        }
        this.previewCardTitle = "IT Change Request (ITCR) #" + this.ITCRid;
      },

      adjustChart: function(){
        var x = document.getElementById(this.stage);
        const container = document.getElementById('scrollableDiv');
        if(x){
          const elementLeft = x.offsetLeft;
          container.scrollTo({
            left: elementLeft,
            behavior: 'smooth'
          });
        }
      },      
     
      //Remind email button for CM
      sendCCBReminder: async function(){
        let emailNotification = "This is a reminder that ITCR #" + this.ITCRid + " is ready for CCB.<br>Change Description: " + this.changeDescription;
        let token = this.$store.getters.getToken;

        try{
          for (var i = 0; i < this.members.rowData.length; i = i + 1) {
            if((this.members.rowData[i].email != this.$store.getters.getEmail) && this.members.rowData[i].completed == false){
              try{
              await sendEmail(this.members.rowData[i].email, "IT CCB Reminder", emailNotification, token, "ViewITCR&id="+this.ITCRid, []);
              } catch (error) {
                console.error('Failed to send email', error);
              }
            }
          }
        } catch(error){
          console.log(error)
          this.p5_fail = true;
        }
        window.scroll({top: 0, behavior: 'smooth'});
      },

      sendDiscussionReminder: async function(){
        let emailNotification = "This is a reminder that ITCR #" + this.ITCRid + " is ready for Discussion.<br>Change Description: " + this.changeDescription;
        let notification = "This is a reminder that ITCR #" + this.ITCRid + " is ready for CCB.";
        let token = this.$store.getters.getToken;
        let msgIds = [];
        let data = [];

        try{
          for (var i = 0; i < this.members.rowData.length; i = i + 1) {
            try{
              await sendEmail(this.members.rowData[i].email, "IT CCB Discussion Reminder", emailNotification, token, "ViewITCR&id="+this.ITCRid, []);
            } catch (error) {
              console.error('Failed to send email', error);
            }

            data = {
              data:{
                details: notification,
                notified: false,
                username: this.members.rowData[i].username,
                userEmail: this.members.rowData[i].email,
                type: "ITCR"
              }
            }
            let res = await DatabaseLib.postRequest('strapiDatabase','notifications',token,data);
            msgIds.push(res.data.data.id);
          }
          try{
            data = {
              data: {
                notifications: msgIds
              }
            }
            await DatabaseLib.putRequest('strapiDatabase','itcrs',token,this.ITCRid,data);
            // Load notifications
            this.bus.$emit('fireMethod');
          } catch(error){
            console.log(error)
          }
        } catch(error){
          console.log(error)
          this.p5_fail = true;
        }
        window.scroll({top: 0, behavior: 'smooth'});
      },

      removeNotification: async function () {
        let token = this.$store.getters.getToken;
        //delete notifications
        let query = "filters[id][$in][0]=" + this.ITCRid + "&populate[1]=notifications";
        let response = await DatabaseLib.getRequest('strapiDatabase','itcrs',token,query,false);
        for(var i = 0; i < response.data.data[0].attributes.notifications.data.length; i++){
          if(response.data.data[0].attributes.notifications.data[i].attributes.type == 'ITCR'){
            await DatabaseLib.deleteRequest('strapiDatabase','notifications',token,response.data.data[0].attributes.notifications.data[i].id);
          }
        }
        // Load notifications
        this.bus.$emit('fireMethod');
      },

      getCCBMemberData: async function(){
        this.isPopUpSetUp = false;
        this.members.rowData = [];
        let token = this.$store.getters.getToken;

        try{
          let query = "filters[itcrType][$eq][0]=" + this.itcrType;
          let ccbResponse = await DatabaseLib.getRequest('strapiDatabase','itcr-ccb-members',token,query,false);

          for(let i = 0; i < ccbResponse.data.data.length; i = i + 1){
            let index = this.ccbs.findIndex(ccb => ccb.attributes.username == ccbResponse.data.data[i].attributes.username);
            let com = "";
            let approve = "---";
            if(index >= 0){
              approve = this.ccbs[index].attributes.approved ? "Approved" : "Disapproved";
              com = this.ccbs[index].attributes.comments;
            }

            this.members.rowData.push({
              name: ccbResponse.data.data[i].attributes.firstLastName,
              username: ccbResponse.data.data[i].attributes.username, 
              approved: approve,
              email: ccbResponse.data.data[i].attributes.email,
              comments: com,
              completed: approve !== "---" ? true : false
            });  
          }
          this.isPopUpSetUp = true;
          let findUser = this.members.rowData.find(user => user.username == this.$store.getters.getUser);
          if(!findUser){this.isWrongUser = true;}
        } catch(error){
          this.isPopUpSetUp = true;
          console.log(error);
          return;
        }
      },
     
      submitData: async function(){
        let token = this.$store.getters.getToken;
        let newData = [];
        const utcTimestamp = new Date().toISOString();
        var index = this.stages.findIndex(x => x.stage === this.selectedStage);
        var tempStage = this.stages[index + 1].stage;

        if(this.siaDisposition == "Disapproved" && this.stage == this.stage_SIA){
            tempStage = this.stage_Closed;
        }
        if((this.verificationPass == "No" && this.stage == this.stage_Verification)){
            tempStage = this.stage_SIA;
            await this.deleteCCBs();
        }
        if(this.selectedStage == this.stage_SIA){
            if(this.siaDisposition == "Pending" || !this.siaNotes){
              // fill out required fields
              this.p6_fail = true;
              this.$nextTick(function() {
                  this.$refs.scrollableDiv.scrollIntoView({behavior: 'smooth'})
              })
              return;
            }

            this.siaReviewerName = await this.getUsersName();
            this.siaNotes = sanitizeInput(this.siaNotes, this.$sanitize);
            this.siaDisposition = sanitizeInput(this.siaDisposition, this.$sanitize);
            this.siaReviewerName = sanitizeInput(this.siaReviewerName, this.$sanitize);

            newData = {
              data: {
                siaReviewerName: this.siaReviewerName,
                siaCompletionDate: utcTimestamp,
                siaDisposition: this.siaDisposition,
                siaNotes: this.siaNotes,
                stage: tempStage,
                closeDate: this.siaDisposition == "Disapproved" && this.stage == this.stage_SIA ? utcTimestamp : null,
                closed: this.siaDisposition == "Disapproved" && this.stage == this.stage_SIA ? true : false
              }
            }
        }
        else if(this.selectedStage == this.stage_Work){
          if(!this.techAssignedToWork || this.workDisposition == "" || !this.workNotes){
            // fill out required fields
            this.p6_fail = true;
            this.$nextTick(function() {
                this.$refs.scrollableDiv.scrollIntoView({behavior: 'smooth'})
            })
            return;
          }
          this.workNotes = sanitizeInput(this.workNotes, this.$sanitize);
          this.workDisposition = sanitizeInput(this.workDisposition, this.$sanitize);
          this.techAssignedToWork = sanitizeInput(this.techAssignedToWork, this.$sanitize);

          newData = {
            data: {
              techAssignedToWork: this.techAssignedToWork,
              workCompletionDate: this.workDisposition != "Complete" ? null : utcTimestamp,
              workDisposition: this.workDisposition,
              workNotes: this.workNotes,
              stage: this.workDisposition != "Complete" ? this.stage : tempStage
            }
          }
        }
        else if(this.selectedStage == this.stage_Verification){
          if(this.verificationPass == "Pending" || !this.verificationNotes){
            // fill out required fields
            this.p6_fail = true;
            this.$nextTick(function() {
                this.$refs.scrollableDiv.scrollIntoView({behavior: 'smooth'})
            })
            return;
          }

          this.testReviewer = await this.getUsersName();
          this.verificationNotes = sanitizeInput(this.verificationNotes, this.$sanitize);
          this.verificationPass = sanitizeInput(this.verificationPass, this.$sanitize);
          this.testReviewer = sanitizeInput(this.testReviewer, this.$sanitize);
          this.workDisposition = sanitizeInput(this.workDisposition, this.$sanitize);
          this.siaDisposition = sanitizeInput(this.siaDisposition, this.$sanitize);

          newData = {
            data: {
              testReviewer: this.testReviewer,
              closeDate: this.verificationPass == "No" ? this.closeDate : utcTimestamp,
              verificationPass: this.verificationPass == "No" ? "Fail" : "Pass",
              verificationNotes: this.verificationNotes,
              stage: tempStage,
              workDisposition: this.verificationPass == "No" ? "Incomplete" : this.workDisposition,
              siaDisposition: this.verificationPass == "No" ? "Pending" : this.siaDisposition,
              ccbDisposition: this.verificationPass == "No" ? "Pending" : this.ccbDisposition,
              closed: this.verificationPass == "No" ? false : true
            }
          }
        }
        try{
            await DatabaseLib.putRequest('strapiDatabase','itcrs',token,this.ITCRid,newData);
            this.p2_success = true;
        } catch(error){
            this.p2 = true;
            console.log(error);
            window.scroll({top: 0, behavior: 'smooth'});
            return;
        }
        window.scroll({top: 0, behavior: 'smooth'});
        this.stage = tempStage;
        this.resetData();
        this.loadITCRData();
      },
     
      //===========================================================================================
      //	Method Name	: completeNextStep
      //	Description
      //	-----------------------------------------------------------------------------------------
      //	Determines which step the user is on and allows them to complete that step
      //===========================================================================================      
      completeNextStep: async function(data){ 
        await this.resetData();
        this.editing = false;
        this.selectedStage = data;
        if(this.stage == this.selectedStage){ this.editing = true; }
        this.detailsTitle = data;
        
        if(this.selectedStage == this.stage_ITCR){
            this.detailsTitle = "Change Request Details";
        } 
        if(this.selectedStage == this.stage_SIA){
            this.detailsTitle = "Security Impact Analysis (SIA)";
            if(this.editing)this.siaReviewerName = await this.getUsersName();
        }
        if(this.selectedStage == this.stage_CCB){
            this.detailsTitle = "IT CCB";
            this.getCCBMemberData();
        }
        if(this.selectedStage == this.stage_Work){
            this.detailsTitle = "IT Work Performed";
            this.getUserList();
        }
        if(this.selectedStage == this.stage_Verification){
            this.detailsTitle = "Verification";
            if(this.editing)this.testReviewer = await this.getUsersName();
        }
        
        this.viewModal = true;
        this.$nextTick(function() {
            this.$refs.scrollableDiv.scrollIntoView({behavior: 'smooth'})
        })
      },


      getUserList: async function(){
        let token = this.$store.getters.getToken;
        let response = '';
        let query = '';

        try 
        {
          query = 'filters[blocked][$eq][0]='+false+'&populate[1]=role&populate[2]=groups';
          response = await DatabaseLib.getRequest('strapiDatabase','users',token,query);
        } 
        catch 
        {
          window.scroll({top: 0, behavior: 'smooth'});
          return;
        }

        for(let i = 0; i < response.data.length; i = i + 1) {
            let index = response.data[i].groups.findIndex(v => v.name == "IT");
            if(response.data[i].role.name != "Administrator" && index >= 0){
                let pushData = { text: response.data[i].firstName + " " + response.data[i].lastName, value: response.data[i].firstName + " " + response.data[i].lastName }
                if(this.techAssignedToWork == response.data[i].firstName + " " + response.data[i].lastName){
                  pushData["selected"] = true;
                }
                this.userOptions.push(pushData);       
            }
        }

      },
     
    //===========================================================================================
    //	Method Name	:	checkApprovalsRejections
    //	Description
    //	-----------------------------------------------------------------------------------------
    //	Check itcr status to see if it is approved or rejected
    //===========================================================================================
    checkApprovalsRejections: async function(){
      let token = this.$store.getters.getToken;
      let isApprovedCCB = false;
      let isRejectedCCB = false;
      let totalApproved = 0;
      let totalRejected = 0;
      let totalMembers = this.members.rowData.length;
      let discussionNeeded = false;
      
      // get total number of approvals
      //Get most current ccbs
      let query = "filters[id][$in][0]=" + this.ITCRid + "&populate[1]=ccbs";
      let response = await DatabaseLib.getRequest('strapiDatabase','itcrs',token,query,false);
      let ccbs = response.data.data[0].attributes.ccbs.data;

      for(let i = 0; i < ccbs.length; i = i + 1) {
        if(ccbs[i].attributes.approved == true){
          totalApproved++;
        } else {
          totalRejected++;
        }
      }

      // 100%
      if(totalRejected == totalMembers){isRejectedCCB = true;}
      else if(totalApproved == totalMembers){ isApprovedCCB = true;}
      else if(totalRejected > 0 && totalApproved > 0){ discussionNeeded = true;}

      // next stage
      var index = this.stages.findIndex(x => x.stage === this.stage);
      var nextStage = this.stages[index + 1].stage;
      
      let data = {
          data: {
            ccbDisposition: isApprovedCCB ? "Approved" : isRejectedCCB ? "Disapproved" : "",
            ccbCompletionDate: isApprovedCCB || isRejectedCCB ? new Date().toISOString() : null,
            stage: isApprovedCCB ? nextStage : isRejectedCCB ? this.stage_Closed : this.stage,
            siaDisposition: this.siaDisposition,
            discussionRequired: discussionNeeded,
            closed: isRejectedCCB ? true : false,
            closeDate: isRejectedCCB ? new Date().toISOString() : null
          }
      }
      await DatabaseLib.putRequest('strapiDatabase','itcrs',token,this.ITCRid,data);

      if(isApprovedCCB || isRejectedCCB){
        await this.removeNotification();
      }
      if(isRejectedCCB){
        await this.deleteCCBs();
      }
      if(discussionNeeded){
        // email CCB members
        await this.sendDiscussionReminder();
      }

      this.resetData();
      this.loadITCRData();
      this.p2_success = true;
    },

    markCCBComplete: async function(statusOfCCB){
      let token = this.$store.getters.getToken;
      var index = this.stages.findIndex(x => x.stage === this.stage);
      var nextStage = this.stages[index + 1].stage;
      const utcTimestamp = new Date().toISOString();
      if(statusOfCCB == "Disapproved"){
        nextStage = this.stage_Closed;
        await this.deleteCCBs();
      }

      this.siaDisposition = sanitizeInput(this.siaDisposition, this.$sanitize);

      let data = {
        data: {
          stage: nextStage,
          ccbCompletionDate: utcTimestamp,
          ccbDisposition: statusOfCCB,
          siaDisposition: this.siaDisposition,
          discussionRequired: false,
          forceDispositionCM: this.$store.getters.getUser,
          closed: statusOfCCB == "Disapproved" ? true : false,
          closeDate: statusOfCCB == "Disapproved" ? utcTimestamp : null
        }
      }

      try{
        await DatabaseLib.putRequest('strapiDatabase','itcrs',token,this.ITCRid,data);
      }catch(error){
        this.p2 = true;
        return;
      }

      this.removeNotification();
      this.resetData();
      this.loadITCRData();
      this.p2_success = true;
      window.scroll({top: 0, behavior: 'smooth'});
    },

      //===========================================================================================
      //	Method Name	:	submitITCRDisposition
      //	Description
      //	-----------------------------------------------------------------------------------------
      //	Handles itcr approvals during a CCB
      //===========================================================================================
      submitITCRDisposition: async function(){
        if(!this.selectedDisposition){
          this.p6_fail = true;
          return;
        }
        this.viewModal = false;
        let token = this.$store.getters.getToken;

        this.new_comments_CCB = sanitizeInput(this.new_comments_CCB, this.$sanitize);
        try {
          let data = {
            data: {
              username: this.$store.getters.getUser,
              firstLastName: await this.getUsersName(),
              comments: this.new_comments_CCB,
              stage: this.stage,
              approved: this.selectedDisposition == "Approved" ? true : false,
              itcr: this.ITCRid
            }
          }
          await DatabaseLib.postRequest('strapiDatabase','ccbs',token,data);
          await this.checkApprovalsRejections();
        } catch(error) {
          window.scroll({top: 0, behavior: 'smooth'});
          this.p2 = true;
          return;
        }
        window.scroll({top: 0, behavior: 'smooth'});
      },

      discussITCR: async function(){
        this.viewModal = false;
        let token = this.$store.getters.getToken;
        try {
          let data = {
            data: {
              discussionRequired: true
            }
          }
          await DatabaseLib.putRequest('strapiDatabase','itcrs',token,this.ITCRid,data);
          this.p2_success = true;
          } catch(error) {
          window.scroll({top: 0, behavior: 'smooth'});
          this.p2 = true;
          return;
        }
        window.scroll({top: 0, behavior: 'smooth'});
        this.sendDiscussionReminder();
        this.resetData();
        this.loadITCRData();
      },

      //===========================================================================================
      //	Method Name	:	getUsersName
      //	Description
      //	-----------------------------------------------------------------------------------------
      //	Get current users name
      //===========================================================================================
      getUsersName: async function(){
        let token = this.$store.getters.getToken;
        let query = "filters[blocked][$eq][0]=" + false + "&filters[username][$eq][1]=" + this.$store.getters.getUser;
        let response = await DatabaseLib.getRequest('strapiDatabase','users',token,query,false);
        if(response.data.length > 0){
          return response.data[0].firstName + " " + response.data[0].lastName;
        }
        return "";
      },

      
      //===========================================================================================
      //	Method Name	:	deleteCCBs
      //	Description
      //	-----------------------------------------------------------------------------------------
      //	Delete CCBs when a itcr is closed or restarted
      //===========================================================================================
      deleteCCBs: async function(){
        let token = this.$store.getters.getToken;
        // refresh CCBs
        let ccbs = [];
        try{
          let response = await DatabaseLib.getRequest('strapiDatabase','itcrs',token,"filters[id][$eq][0]="+this.ITCRid+"&populate[1]=ccbs",false);
          ccbs = response.data.data[0].attributes.ccbs;
        }catch(error){
          console.log(error);
        }
        
        for (let i = 0; i < ccbs.data.length; i++) {
          try {
            await DatabaseLib.deleteRequest(
              'strapiDatabase',
              'ccbs',
              token,
              ccbs.data[i].id
            );
          } catch (err) {
            console.error("Failed on index", i, ccbs.data[i], err);
          }
        }
      },


      //===========================================================================================
      //	Method Name	:	closeITCR
      //	Description
      //	-----------------------------------------------------------------------------------------
      //	Closes a itcr
      //===========================================================================================
      closeITCR: async function(){
        if(!this.closeRequestReason){
          this.closeFail = true;
          return;
        }

        this.closeRequestReason = sanitizeInput(this.closeRequestReason, this.$sanitize);
        let token = this.$store.getters.getToken;
        this.viewCloseConfirm = false;
        let data = {
          data:{
            stage: "Closed",
            closed: true,
            closeDate: new Date().toISOString(),
            closeRequestReason: this.closeRequestReason
          }
        }
        try{
          await DatabaseLib.putRequest('strapiDatabase','itcrs',token,this.ITCRid,data);
          this.p1_success = true;
        } catch(error) {
          window.scroll({top: 0, behavior: 'smooth'});
          this.p2_fail = true;
          return;
        }
        this.p1_success = true;
        this.loadITCRData();
        this.resetData();
        window.scroll({top: 0, behavior: 'smooth'});
      },
      
           
      //===========================================================================================
      //	Method Name	:	checkCRTable
      //	Description
      //	---------------------------------------------------------------------------------------
      //	Check groups to see what buttons need to be disabled for each change request
      //===========================================================================================
      checkCRTable: async function(){
        let token = this.$store.getters.getToken;
        this.isWrongUser = false;
        
        let query = "filters[username][$eq][0]="+ this.$store.getters.getUser;
        let response = await DatabaseLib.getRequest('strapiDatabase','itcr-ccb-members',token,query);
        let loggedInUserGroups = response.data.data.map(group => group.attributes.itcrType);

        if(this.closed){this.isWrongUser = true;}
        else {
          if((this.stage == this.stage_SIA) && this.isIntern){this.isWrongUser = true;}
          if((this.isCM || this.isOnlyCCB) && !this.isIT && this.stage != this.stage_CCB){this.isWrongUser = true;}    

          response = await DatabaseLib.getRequest('strapiDatabase','users',token,query);
          let name = response.data[0].firstName + " " + response.data[0].lastName;

          if(name == this.techAssignedToWork && this.stage == this.stage_Verification){this.isWrongUser = true;}
          if(this.isAdmin){this.isWrongUser = false;}
          
          if(this.stage == this.stage_CCB && !loggedInUserGroups.includes(this.itcrType)){this.isWrongUser = true;}  

          //Disable start button if stage is in CCB and user has completed it
          if(this.ITCRid && this.stage.includes("CCB")){
            let index = this.ccbs.findIndex(ccb => ccb.attributes.username == this.$store.getters.getUser);
            if(index >= 0){
              this.isWrongUser = true;
            }
          }
        }
      },

      //===========================================================================================
      //	Method Name	:	checkGroups
      //	Description
      //	-----------------------------------------------------------------------------------------
      //	Determine what groups the user belongs to
      //===========================================================================================
      checkGroups: async function(){
        if (this.$store.getters.getRole == "Administrator"){
          this.isAdmin = true;
        }
        if (this.$store.getters.getGroups.includes("CM")){
          this.isCM = true;
        }
        if (this.$store.getters.getGroups.includes("IT")){
          this.isIT = true;
          // get intern
          let token = this.$store.getters.getToken;
          let query = "filters[username][$eq][0]="+this.$store.getters.getUser;
          let response = await DatabaseLib.getRequest('strapiDatabase','users',token,query,false);
          if(response.data.length > 0 && response.data[0].title == "Intern"){
              this.isIntern = true;
          }
        }
         if(this.$store.getters.getGroups.includes("CCB") && (!this.isCM && !this.isAdmin && !this.isIT)){
          this.isOnlyCCB = true;
        }
      },

      //===========================================================================================
      //	Method Name	:	returnToITCRs
      //	Description
      //	-----------------------------------------------------------------------------------------
      //	Go back to previous page
      //===========================================================================================
      returnToITCRs: function(){
        this.$router.push({
          name: 'ITCR'
        })
      },

      //===========================================================================================
      //	Method Name	:	bindProps
      //	Description
      //	-----------------------------------------------------------------------------------------
      //	Get data passed to the page in props
      //===========================================================================================
      bindProps: function(){
        this.ITCRid = parseInt(this.$route.query.id);
        if(this.ITCRid){
          this.loadITCRData();
        }
      }

    },
     watch: {
      isUrgent: function() {
        this.setUrgent();
      }

    },
    mounted(){
      window.scroll({top: 0, behavior: 'smooth'});
      this.bindProps();
      window.addEventListener('scroll', this.handleScroll);
    },
    beforeDestroy() {
      window.removeEventListener('scroll', this.handleScroll);
    },
  }
  </script>
